module.exports = __webpack_public_path__ + "static/img/three.db59755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallFishImg/three.png
// module id = V9fz
// module chunks = 1